import type { PartnerWallet, WalletBalances } from 'src/interfaces/wallet'

export const sumWalletBalances = (wallets: PartnerWallet[]): WalletBalances => {
  return wallets.reduce<WalletBalances>(
    (totals, wallet) => {
      return {
        totalBalance: totals.totalBalance + (Number(wallet.totalBalance) || 0),
        availableBalance: totals.availableBalance + (Number(wallet.availableBalance) || 0),
      }
    },
    { totalBalance: 0, availableBalance: 0 },
  )
}
